module.exports = require("./dist/waves.js");
require("./dist/waves.css");


//////////////////
// WEBPACK FOOTER
// waves (bower component)
// module id = 487
// module chunks = 1